import Policy from './Policy'

// Backend policies resolved in: backend/components/timeoff/app/presenters/timeoff/leave_policies_presenter.rb
export type LeaveVerbTypes =
  | 'approveLeave'
  | 'deleteLeave'
  | 'manageLeaveDocuments'
  | 'updateLeave'
  | 'overrideApprovalFlow'

class LeavePolicy extends Policy<LeaveVerbTypes> {
  checkVerb(verb: LeaveVerbTypes): boolean {
    switch (verb) {
      case 'approveLeave':
        return this.permissions.approve

      case 'deleteLeave':
        return this.permissions.delete

      case 'manageLeaveDocuments':
        return this.permissions.manage_documents

      case 'updateLeave':
        return this.permissions.update

      case 'overrideApprovalFlow':
        return this.permissions.override_approval_flow

      default:
        throw new Error(`Unknown verb ${verb} in policy`)
    }
  }
}

export default LeavePolicy
